<template>
	<div>
		<p>
			{{
				selectRandom([
					"Eligible participants were ",
					"The participant characteristics are ",
					"The attributes of the participants include ",
					"The characteristics of the participants are as follows "
				])
			}}
			{{
				joinArrayWithOr(
					formatSelectMulti($tera.project.TrialWizard.conditions)
				).toLowerCase()
			}}
			{{
				$tera.project.TrialWizard.severity &&
				$tera.project.TrialWizard.severity.length > 0
					? `(${joinArrayWithOr(
							formatSelectMulti($tera.project.TrialWizard.severity)
					  ).toLowerCase()})`
					: ""
			}}
			{{
				joinArrayWithOr(
					formatSelectMulti($tera.project.TrialWizard.sexes)
				).toLowerCase()
			}}
			{{
				joinArrayWithOr(
					formatSelectMulti($tera.project.TrialWizard.ages)
				).toLowerCase()
			}}
			{{
				$tera.project.TrialWizard.ageBracket &&
				$tera.project.TrialWizard.ageBracket != ""
					? `(${$tera.project.TrialWizard.ageBracket})`
					: ""
			}}
			{{
				$tera.project.TrialWizard.others && $tera.project.TrialWizard.others.length
					? " who were "
							.concat(formatSelectMulti($tera.project.TrialWizard.others))
							.toLowerCase()
					: ""
			}}.
			{{ selectRandom(["If participants were"]) }}
			{{
				$tera.project.TrialWizard.othersExcluded &&
				$tera.project.TrialWizard.othersExcluded.length
					? joinArrayWithOr(
							formatSelectMulti($tera.project.TrialWizard.othersExcluded)
					  ).toLowerCase()
					: "BLANK"
			}}
			{{ selectRandom(["they were excluded from the study"]) }}.
		</p>
		<p>
			{{
				selectRandom([
					"At baseline, for all participants we are measuring ",
					"We are measuring the following baseline characteristics ",
					"We are going to record the following baseline characteristics ",
					"The baseline characteristics we are planning to measure, include "
				])
			}}
			{{
				joinArrayWithAnd(
					formatSelectMulti($tera.project.TrialWizard.baselineMeasurements)
				).toLowerCase()
			}}.
		</p>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputEligibilityCriteria",
	mixins: [OutputMixin]
};
</script>
